/**
 * ? @description : Add Ungrouped Members to the Batch
 */

// Dependencies
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { useDispatch } from "react-redux";

// Ag-Grid CSS
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

// Axios Component
import Axios from "../../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../../redux/features/appSlice";
import { ShowListInTooltip } from "../../../../../Reusable/ShowListInTooltip";
import { LoadingButton } from "@mui/lab";
import dayjs from "dayjs";
import axios from "axios";

function UngroupedTeacher(props) {
  // console.log(props);
  // * Redux Variables
  const dispatch = useDispatch();

  // * User id
  const user_id = sessionStorage.getItem("user_id");

  // * State Variables
  const [selectedValue, setSelectedValue] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [loading, setLoading] = useState(false);

  // * Columns Definition For Table Data
  const columnHeader = [
    {
      headerName: "Select",
      // field: "teacher_id",
      sortable: true,
      filter: true,
      checkboxSelection: true,
      headerCheckboxSelection: true,
    },
    {
      headerName: "Teacher Name",
      field: "teacher_name",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Languages",
      field: "teacherlanguages",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Email",
      field: "email",
      sortable: true,
      filter: true,
    },
    {
      headerName: "Tentative start date",
      field: "tentative_start_date",
      sortable: true,
      filter: true,
      cellRenderer: (params) => {
        return dayjs(params.value).format("DD-MM-YYYY")
      }
    },
    {
      headerName: "Contact number",
      field: "contactno",
      sortable: true,
      filter: true,
    }
    // {
    //   headerName: "Group count",
    //   field: "batch_count",
    //   sortable: true,
    //   filter: true,
    //   cellRenderer: (params) => {
    //     let id = params.data.teacher_id
    //     return(
    //       params.value !== 0 ? <ShowListInTooltip value={params.value} getUrl={`teacher/batchesnames/teachers/${id}`} property="batch_name"></ShowListInTooltip> : "(0)"
    //     )
    //   }
    // },
    // {
    //     headerName: "Teacher Status",
    //     field: "teacher_status",
    //     sortable: true,
    //     filter: true
    // },
  ];

  // * Filter Data From Table Data
  const onFilterTextChange = (e) => {
    filterData.setQuickFilter(e.target.value);
  };

  // ? API Call : Get Method : Get All Teachers Data From Server
  const onGridReady = async (params) => {
    const controller = axios.CancelToken.source();
    try {
      setFilterData(params.api);

      const response = await Axios("get", `teacher/get/batch/view/activeteacherslist`, true, null, { cancelToken: controller.token });

      // const batches = await Axios("get", `teacher/countofbatches/teachers/add/batch/${props.getbatchid}`, true, null);

      if (!Array.isArray(response.data)) {
        response.data = [];
      }
      // console.log(batches.data);
      // const overallList = await teachers.data.map((teachers) => {
      //   let index = batches.data.findIndex(item => item.teacher_id === teachers.teacher_id)
      //   return index !== -1 ? {...teachers, batch_count: batches.data[index].batch_count} : {...teachers, batch_count: 0}

      // })

      // console.log(overallList);
      params.api.applyTransaction({ add: response.data });
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.log(error);
        dispatch(
          showSnackbar({
            message: "Error occurred! Unable to fetch data.",
            severity: "error",
          })
        );
      }

    }
    return () => {
      controller.cancel();
    }
  };
  // const onGridReady = async (params) => {
  //   try {
  //     setFilterData(params.api);

  //     const options = {
  //       method: "GET",
  //       url: "/batchview/ungroupedteachers",
  //       auth: true,
  //       data: null,
  //     };

  //     const response = await Axios(
  //       options.method,
  //       options.url,
  //       options.auth,
  //       options.data
  //     );

  //     params.api.applyTransaction({ add: response.data });
  //   } catch (error) {
  //     dispatch(
  //       showSnackbar({
  //         message: "Error occurred! Unable to fetch data.",
  //         severity: "error",
  //       })
  //     );
  //   }
  // };

  // * Row Selection Event : "Multiple"
  const rowSelectionType = "multiple";

  // * Store Selected Row Data to State Variable
  const onSelectionChanged = (event) => {
    setSelectedValue(event.api.getSelectedRows());
  };

  // ! Selected Row Data Pushed to Local Array Variable
  const createArrayValues = () => {
    let formLocalBatchData = [];

    selectedValue.map((teacher) => {
      return formLocalBatchData.push({
        batch_member_id: teacher.teacher_id,
        batch_member_type: "teacher",
        batch_member_name: teacher.teacher_name,
        batch_ids: props.getbatchid,
        batch_name: props.getbatchname,
        batch_member_created_by: user_id,
      });
    });

    return formLocalBatchData;
  };

  // ? API Call : Post Method : Add Batch Members
  const postUngroupedTeachers = async () => {
    try {
      let formGroupedTeacherData = [];

      formGroupedTeacherData = createArrayValues();

      if (formGroupedTeacherData.length > 0) {
        setLoading(true)
        const options = {
          method: "POST",
          url: "/batchmembers",
          auth: true,
          data: formGroupedTeacherData,
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data
        );

        if (response.status === 201) {
          props.onHide();
          window.location.reload();
          // props.onCloseCallBack();
          dispatch(
            showSnackbar({
              message: "Teachers added to the Group successfully !",
              severity: "success",
            })
          );

          setLoading(false);
          // props.handleAttendanceModalClose();
        }
      } else {
        setLoading(false)
        dispatch(
          showSnackbar({
            message: "Please select atleast one teacher to add !",
            severity: "error",
          })
        );
      }
    } catch (error) {
      setLoading(false)
      dispatch(
        showSnackbar({
          message:
            "Error occurred! Unable to post data. Please try again later.",
          severity: "error",
        })
      );
    }
  };

  return (
    <div>
      <Modal
        {...props}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h5>Ungrouped Members List</h5>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <input
            type="search"
            name="search"
            placeholder="Search Here"
            className="p-2"
            style={{
              width: "200px",
              padding: "10px",
              border: "1px solid #1D3FAA",
              borderRadius: "20px",
              outline: "none",
            }}
            onChange={onFilterTextChange}
          />

          <div
            className="ag-theme-alpine my-3"
            style={{ width: "90%", height: "300px", margin: "0 auto" }}
          >
            <AgGridReact
              onGridReady={onGridReady}
              columnDefs={columnHeader}
              rowSelection={rowSelectionType}
              onSelectionChanged={onSelectionChanged}
              rowMultiSelectWithClick={true}
              pagination={true}
              paginationPageSize={10}
              paginationAutoPageSize={true}
            />
            {/* <p>
              {selectedValue.map((value, index) => {
                return <li key={index}>{value.teacher_name}</li>
              })}
            </p> */}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div>
            <Button type="button" variant="light" onClick={props.onHide}>
              CLOSE
            </Button>

            <LoadingButton
              type="submit"
              variant="primary"
              loading={loading}
              className="batchSave"
              sx={{ color: 'white' }}
              onClick={postUngroupedTeachers}
            >
              ADD
            </LoadingButton>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default UngroupedTeacher;
